




























































import { Component, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { DetailItem, EmailDetailItemInfo } from "@/store/email/statistic/types";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import EmailEventsDetailFilter from "@/components/Email/EmailEventsDetailFilter.vue";
import { dateFilter } from "@/utils/date-util";

@Component({ components: {EmailEventsDetailFilter}, filters: {dateFilter} })
export default class EmailEventsDetail extends BaseItemsPage<DetailItem> {
  @Prop() message!: EmailDetailItemInfo;

  @Getter("emailStatisticDetail") responseItems: any;

  currentSort = "date";

  tableFields = this.tableFieldsDefault;

  messageId = ''

  created() {
    this.messageId = this.$route.params.id.replace(/#/g, '%23');
  }

  get tableFieldsDefault() {
    return [
      "date",
      "type",
      "detail"
    ];
  }

  getData() {
    return this.responseItems;
  }

}
